import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 2 20.1499)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 2 25)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 11.8102 10.4498)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 11.8102 15.2998)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 11.8102 20.1499)"
      className="box-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 11.8102 25)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 21.6204 10.4498)"
      className="box-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 6.90509 15.2998)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 6.90509 20.1499)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 6.90509 25)"
      className="box-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 16.7153 10.4498)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 16.7153 15.2998)"
      className="box-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 16.7153 20.1499)"
      className="box-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 16.7153 25)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 21.6204 15.2998)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 26.5255 15.2998)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 21.6204 20.1499)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      x="0.25"
      y="-0.25"
      width="2.97445"
      height="2.94976"
      transform="matrix(1 0 0 -1 21.6204 24.5)"
      className="line-fill"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <rect
      width="3.47445"
      height="3.44976"
      transform="matrix(1 0 0 -1 26.5255 10.4498)"
      className="line-fill"
      fill="currentColor"
    />
    <rect
      x="0.25"
      y="-0.25"
      width="2.97445"
      height="2.94976"
      transform="matrix(1 0 0 -1 26.5255 19.6499)"
      className="line-fill"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <rect
      x="0.25"
      y="-0.25"
      width="2.97445"
      height="2.94976"
      transform="matrix(1 0 0 -1 26.5255 24.5)"
      className="line-fill"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <rect
      x="0.25"
      y="-0.25"
      width="2.97445"
      height="2.94976"
      transform="matrix(1 0 0 -1 6.90509 9.94977)"
      className="line-fill"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <rect
      x="0.25"
      y="-0.25"
      width="2.97445"
      height="2.94976"
      transform="matrix(1 0 0 -1 2 9.94977)"
      className="line-fill"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <rect
      x="0.25"
      y="-0.25"
      width="2.97445"
      height="2.94976"
      transform="matrix(1 0 0 -1 2 14.7998)"
      className="line-fill"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>,
  'HeatMapIcon'
);

export const HeatMapIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.box-fill': {
          color: theme.palette.status.success.highContrast,
        },
        '.line-fill': {
          color: theme.palette.status.success.main,
          stroke: theme.palette.status.success.main,
        },
      })}
    />
  );
};
